<div class="modal-body p-4 w-100">
<div class="flex justify-content-center">
  <div class="flex justify-content-center" *ngIf="leg">
    <app-change-flights-departing-flight-information [leg]="leg" [delayCodes]="delayCodes"></app-change-flights-departing-flight-information>
  </div>
</div>
</div>
